// Web NFC (NDEFReader) só existe no Chrome Android — nenhum navegador de
// iPhone nem desktop suporta. Por isso todo ponto de verificação também tem
// QR code (ver Rotas.js) como método que funciona em qualquer aparelho; NFC
// aqui é um atalho a mais quando dá, não o único caminho.
export function nfcDisponivel() {
  return typeof window !== "undefined" && "NDEFReader" in window;
}

// Liga o leitor, espera UMA leitura, desliga sozinho. `serialNumber` do evento
// é o identificador físico do chip — é isso que vira `codigo_nfc` tanto no
// cadastro (Rotas.js, pareando o cartão a um ponto) quanto na validação
// (FazerRota.js, comparando o que foi lido com o que está cadastrado).
export function lerNfcUmaVez({ timeoutMs = 15000 } = {}) {
  return new Promise((resolve, reject) => {
    if (!nfcDisponivel()) {
      reject(new Error("Esse navegador não suporta leitura de NFC (funciona só no Chrome do Android)."));
      return;
    }

    let finalizado = false;
    const finalizar = (fn, valor) => {
      if (finalizado) return;
      finalizado = true;
      clearTimeout(timer);
      fn(valor);
    };
    const timer = setTimeout(
      () => finalizar(reject, new Error("Tempo esgotado esperando o NFC. Encoste o celular no cartão e tente de novo.")),
      timeoutMs
    );

    const reader = new window.NDEFReader();
    reader
      .scan()
      .then(() => {
        reader.onreading = (event) => finalizar(resolve, event.serialNumber);
        reader.onreadingerror = () => finalizar(reject, new Error("Não foi possível ler esse cartão NFC. Tente de novo."));
      })
      .catch(() => finalizar(reject, new Error("Permissão de NFC negada ou leitor indisponível nesse aparelho.")));
  });
}
